import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoLastName = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="family-name"
  errorMessages={{
    'field_is_required': 'The last name field is required',
    'field_is_invalid': 'Your last name is invalid',
  }}
  label="Last Name"
  name="lastName"
/>
  );

export default CustomerContactInfoLastName;
